module.exports = __webpack_public_path__ + "img/xsbm.cf27f778.jpg";